import img1 from '../Categories/imagesCategories/mobile.png';
import img2 from '../Categories/imagesCategories/computer.png';
import img3 from '../Categories/imagesCategories/watch.png';
import img4 from '../Categories/imagesCategories/camera.png';
import img5 from '../Categories/imagesCategories/headphones.png';
import img6 from '../Categories/imagesCategories/gaming.png';


export const CategoryData=[
    {
        id: 7,
     img : img1,
     title:"Phones"
    },
     {
        id: 8,
        img : img2,
        title:"Computers"
       },
        {
            id: 9,
        img : img3,
        title:"SmartWatch"
       },
        {
            id: 10,
        img : img4,
        title:"Camera"
       }, {
        id: 11,
        img : img5,
        title:"HeadPhones"
       },
        {
            id:12 ,
        img : img6,
        title:"Gaming"
       }, {
        id: 13,
        img : img3,
        title:"SmartWatch"
       },
]